import { useCreate, useGetIdentity } from '@refinedev/core';
import { notify, notifyError } from 'components/shared/Toastify';
import FormRow from 'HOC/FormRow';
import React, { Dispatch, SetStateAction } from 'react';
import { useProjectStore } from 'store/projects.store';
import { IStoryItem, useStoryStore } from 'store/userStory.store';
import { IIdentity } from 'types/identitytypes';

export const AddUserStoryForms = ({
  setOpenModal,
  projectId,
}: {
  projectId: string | null;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}) => {
  const addStoryItem = useStoryStore((state) => state.addStoryItem);
  const projectItemId = useProjectStore((state) => state.projectItemID);
  const addStoryItemID = useStoryStore((state) => state.addStoryItemID);
  const initialValues = {
    story: '',
    storyDetails: '',
    intendedAudience: '',
    priority: '',
  };
  const { mutate, isLoading } = useCreate<IStoryItem>();
  const { data: user } = useGetIdentity<IIdentity>();
  const [value, setValue] = React.useState(initialValues);

  const handleChange = (e: { target: { name: string; value: string } }) => {
    setValue((prevValue) => ({
      ...prevValue,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const payload = {
      story: value.story,
      storyDetails: value.storyDetails,
      intendedAudience: value.intendedAudience,
      uid: user?.id,
      priority: value.priority,
      projectId: projectItemId,
    };

    mutate(
      { resource: 'user-story', values: payload },
      {
        onSuccess: (data) => {
          if (data.data) {
            addStoryItemID(data.data._id);
            addStoryItem(data.data);
            notify('Story saved successfully');
            setOpenModal(false);
          }
        },
        onError: (error) => {
          notifyError(error.response.data.errorMsg);
        },
      }
    );
  };

  return (
    <>
      <div className=''>
        <form
          onSubmit={handleSubmit}
          className='w-[75vw] max-w-[100vw] md:w-[40rem] flex flex-col'>
          <FormRow
            labelText='User Story'
            name='story'
            type='text'
            placeholder='E.g. Sales Pipeline'
            value={value.story}
            handleChange={handleChange}
          />
          <FormRow
            labelText='Story Details'
            textArea='textArea'
            name='storyDetails'
            placeholder='E.g. I want to get the details of the sales pipeline'
            value={value.storyDetails}
            handleChange={handleChange}
          />

          <FormRow
            labelText='Intended Audience'
            name='intendedAudience'
            type='text'
            placeholder='E.g. Regional Director'
            value={value.intendedAudience}
            handleChange={handleChange}
          />

          <label htmlFor='userPriority'>Priority</label>
          <select
            onChange={handleChange}
            value={value.priority}
            name='priority'
            id='userPriority'
            className='outline-none border-[1px] border-slate-400  p-2 mb-8 rounded-xl mt-4'>
            <option value='' disabled>
              Select Priority
            </option>
            <option value='High'>High</option>
            <option value='Medium'>Medium</option>
            <option value='Low'>Low</option>
          </select>

          <div className='grid place-items-center'>
            <button
              disabled={isLoading}
              type='submit'
              className={
                isLoading
                  ? 'cursor-not-allowed w-28 h-fit bg-blue-400 text-white p-3 rounded-md'
                  : 'w-28 h-fit bg-blue-400 text-white p-3 rounded-md'
              }>
              {isLoading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
